module.exports = __webpack_public_path__ + "images/1253f0fd4d6cc0bc220e0cde2df427323d.svg";